import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { KEYS, normalizeKey } from '../lib/keys';

// R-KEY dropdown (D24). `value` is a canonical key or null; a legacy sharp shows as its flat (B1).
export default function KeySelect({ value, onChange, disabled = false, className = '', ...rest }) {
  return (
    <Select value={normalizeKey(value) || value || undefined} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={`h-9 w-[76px] ${className}`} {...rest}>
        <SelectValue placeholder="Key" />
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {KEYS.map((k) => (
          <SelectItem key={k} value={k}>{k}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
